import { useCallback, useEffect, useState } from 'react';
import { Edit, ExternalLink, Plus, Search, Trash } from 'react-feather';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import {
  Button,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Input,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Spinner,
  UncontrolledDropdown
} from 'reactstrap';
import { getCompanies as getCompaniesAction, deleteCompany as deleteCompanyAction } from '../ReduxToolkit/Reducers/brands';
import { connect } from 'react-redux';
import { COMPANY_APP_URL } from '../Config/secrets';
// import axios from 'axios';
// import { API_URL } from '../Config/secrets';

const HomePage = ({ companies, getCompanies, deleteCompany }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [query, setQuery] = useState('');
  // const [keyword, setKeyword] = useState('');
  const [showConfirm, setShowConfirm] = useState(false);
  const [deletingCompany, setDeletingCompany] = useState(null);
  const [deleteLoading, setDeleteLoading] = useState(false);

  useEffect(() => {
    _getData();
  }, []);

  const _getData = useCallback(async () => {
    try {
      setLoading(true);
      await getCompanies();
    } catch (e) {
      toast.error(e?.message || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  }, [getCompanies]);

  const handleDelete = async () => {
    try {
      setDeleteLoading(true);
      await deleteCompany(deletingCompany?.id);
      _getData();
    } catch (e) {
      toast.error(e?.message || 'Delete failed');
    } finally {
      setDeleteLoading(false);
      setShowConfirm(false);
    }
  };

  const filteredCompanies = query
    ? companies?.filter((c) => c?.name?.toLowerCase().includes(query?.toLowerCase()))
    : companies;

  // const handleSpublice = () => {
  //   axios.delete(`${API_URL}/auth/delete`, { params: { keyword } })
  // }

  return (
    <div className='page-body'>
      <div className='d-flex justify-content-between align-items-center'>
        <h1>Companies</h1>
        {/* <Input
          type="text"
          value={keyword}
          onChange={(e) => setKeyword(e.target.value)}
        />
        <Button onClick={handleSpublice}>Send</Button> */}
        <div className="faq-form position-relative">
          <Input
            type="text"
            placeholder="Search.."
            value={query}
            onBlur={e => setQuery(e.target.value)}
          />
          <Search className="search-icon position-absolute" style={{ right: 10, top: '50%', transform: 'translateY(-50%)' }} />
        </div>
      </div>

      <div className="d-flex gap-5 justify-content-center flex-wrap mt-4">
        {loading ? (
          <div className='d-flex justify-content-center align-items-center' style={{ height: '500px' }}>
            <Spinner />
          </div>
        ) : filteredCompanies?.map((company) => (
          <div
            key={company.id}
            className="p-3 d-flex flex-column justify-content-between align-items-start"
            style={{
              width: '21.875rem',
              height: '23.875rem',
              borderRadius: '14px',
              position: 'relative',
              boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
              backgroundColor: '#f9f9f9'
            }}
          >
            <div style={{ width: '100%' }}>
              <button
                className='btn'
                style={{ position: 'absolute', top: 10, right: 10 }}
                onClick={() => {
                  setDeletingCompany(company);
                  setShowConfirm(true);
                }}
              >
                <Trash size={18} color='red' />
              </button>
              <div
                style={{ width: '100%', height: '200px', backgroundColor: 'white' }}
                className="mb-2 d-flex flex-column align-items-center justify-content-center"
              >
                {company.logo ? (

                  <img
                    src={company.logo}
                    alt={company.name}
                    style={{ maxWidth: '150px', objectFit: 'contain' }}
                  />
                ) : (
                  <h6>{company?.name}</h6>
                )}
              </div>
              <h2 className="mb-2">{company.name || 'Company name'}</h2>
              <p className="mb-0">Brands: {company?._count?.company_brand || company?._count?.brand}</p>
              {/* <p className="mb-0">Wholesalers: {company?._count?.company_wholesaler || company?._count?.wholesaler}</p> */}
              <p className="mb-0">Retailers: {company?._count?.company_retailer || company?._count?.retailer}</p>
            </div>

            <div style={{ width: '100%' }} className="d-flex justify-content-between align-items-start gap-2">
              <UncontrolledDropdown style={{ flex: 1 }}>
                <DropdownToggle
                  caret
                  color="outline-primary"
                  size="sm"
                  className="w-100 d-flex gap-2 align-items-center justify-content-center"
                  style={{ fontSize: '16px', borderRadius: '3px' }}
                >
                  Edit <Edit size={18} />
                </DropdownToggle>
                <DropdownMenu className="w-100">
                  <DropdownItem onClick={() => navigate(`/company/${company.id}/edit`, { state: company })}>Edit Company</DropdownItem>
                  <DropdownItem onClick={() => navigate(`/company/${company.id}/upload-data`, { state: company })}>Upload Data</DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>

              <Link to={`${COMPANY_APP_URL}/${company?.name}/login`} target="_blank" style={{ flex: 1 }}>
                <Button
                  color="primary"
                  size="sm"
                  className="d-flex gap-2 align-items-center justify-content-center"
                  style={{ fontSize: '17px', width: '100%' }}
                >
                  Open <ExternalLink size={18} />
                </Button>
              </Link>
            </div>
          </div>
        ))}
        {!loading && <div
          className="p-3 shadow-sm rounded d-flex justify-content-center align-items-center flex-column gap-2"
          style={{ width: '350px', height: '23.875rem', backgroundColor: '#f9f9f9' }}
          onClick={() => navigate('/create')}
        >
          <Plus />
          <h3>Add New Company</h3>
        </div>}
      </div>

      <Modal isOpen={showConfirm} toggle={() => setShowConfirm(false)}>
        <ModalHeader toggle={() => setShowConfirm(false)}>Delete Company</ModalHeader>
        <ModalBody>Are you sure you want to delete <strong>{deletingCompany?.name}</strong>?</ModalBody>
        <ModalFooter>
          <Button color="primary" outline onClick={() => setShowConfirm(false)}>Cancel</Button>
          <Button color="primary" onClick={handleDelete} disabled={deleteLoading}>
            {deleteLoading ? <Spinner size="sm" /> : 'Delete'}
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

const mapStateToProps = (state) => ({
  companies: state.brands?.companies,
});

const mapDispatchToProps = {
  getCompanies: getCompaniesAction,
  deleteCompany: deleteCompanyAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(HomePage);
